import type { VariableValue } from "@skilitics/nautilus-core";
import type { VariableConfig } from "@skilitics/nautilus-core-designer-data";

export const getReferenceId = <T extends VariableValue = VariableValue>(value?: VariableConfig<T>) =>
  typeof value === "object" && value.type === "reference" && "refId" in value ? value.refId : "";

/**
 * The value the variable starts with, known while authoring: the literal itself, or a scoped
 * config's initialValue. `undefined` for a reference config, which only resolves at runtime.
 */
export const getInitialValue = <T extends VariableValue = VariableValue>(value?: VariableConfig<T>): T | undefined => {
  if (typeof value !== "object") return value;
  return value.type === "scoped" ? value.initialValue : undefined;
};
